import { render, staticRenderFns } from "./statusItemV3.vue?vue&type=template&id=15e37c30&scoped=true&"
import script from "./statusItemV3.vue?vue&type=script&lang=js&"
export * from "./statusItemV3.vue?vue&type=script&lang=js&"
import style0 from "./statusItemV3.vue?vue&type=style&index=0&id=15e37c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e37c30",
  null
  
)

export default component.exports